import { isCustomerNumberUnknownInAAX } from '../api/validation.service';
import { patterns } from '../settings';

export const isCustomerNumber = (value: string) => patterns.CUSTOMER_NUMBER_STRING.test(value);
export const preventedIsCustomerNumberUnknownInAAX = (telekomKdnr: string) => {
    if (!isCustomerNumber(telekomKdnr)) {
        return Promise.resolve(false);
    }
    return isCustomerNumberUnknownInAAX(telekomKdnr);
};
